/**
 * Created by sebastianfuss on 03.09.16.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageScrollService } from './ng2-page-scroll.service';
import { PageScroll } from './ng2-page-scroll.directive';
var Ng2PageScrollModule = Ng2PageScrollModule_1 = (function () {
    function Ng2PageScrollModule() {
    }
    Ng2PageScrollModule.forRoot = function () {
        return {
            ngModule: Ng2PageScrollModule_1,
            providers: [
                { provide: PageScrollService, useClass: PageScrollService }
            ]
        };
    };
    return Ng2PageScrollModule;
}());
Ng2PageScrollModule = Ng2PageScrollModule_1 = __decorate([
    NgModule({
        imports: [CommonModule],
        declarations: [PageScroll],
        exports: [PageScroll]
    })
], Ng2PageScrollModule);
export { Ng2PageScrollModule };
var Ng2PageScrollModule_1;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-page-scroll/src/ng2-page-scroll.module.js
// module id = 373
// module chunks = 0